/** The configuration variable keys */
export enum ConfigVar {
    /** The runtime environment */
    NODE_ENV = "NODE_ENV",
}
